// Topic words for guide search (slug -> topics)
export const ARTICLE_TOPICS = {
  "grounding-techniques-for-anxiety": ["anxiety", "grounding", "panic", "stress"],
  "box-breathing-2-minute-reset": ["breathing", "stress", "anxiety", "calm"],
  "how-to-make-a-safety-plan": ["safety", "crisis", "suicide", "plan"],
  "journaling-prompts-for-hard-days": ["journaling", "writing", "hard days", "low mood"],
  "how-to-support-a-friend-who-is-struggling": ["supporting others", "friends", "family"],
  "understanding-your-emotions": ["emotions", "feelings", "self-awareness"],
  "how-to-calm-anxiety-at-night": ["sleep", "anxiety", "night", "insomnia"],
  "what-to-do-during-a-panic-attack": ["panic", "anxiety", "breathing", "grounding"],
  "self-compassion-how-to-be-kinder-to-yourself": ["self-compassion", "kindness", "self-esteem"],
  "signs-of-burnout-and-how-to-recover": ["burnout", "work", "stress", "exhaustion"],
  "how-to-stop-overthinking": ["overthinking", "anxiety", "worry", "rumination"],
  "5-minute-morning-routine-for-mental-health": ["morning", "routine", "habits"],
  "sleep-hygiene-habits-for-better-sleep": ["sleep", "habits", "insomnia", "tired"],
  "what-to-do-when-you-wake-up-at-3am": ["sleep", "night", "insomnia", "anxiety"],
  "burnout-vs-depression-how-to-tell-the-difference": ["burnout", "depression", "low mood", "work"],
  "how-to-set-boundaries-at-work-to-prevent-burnout": ["burnout", "work", "boundaries", "stress"],
  "coping-with-grief-after-a-loss": ["grief", "loss", "bereavement"],
  "how-to-support-someone-who-is-grieving": ["grief", "loss", "supporting others"],
};

export const TOPIC_CHIPS = ["Anxiety", "Sleep", "Burnout", "Grief", "Panic", "Breathing", "Journaling", "Supporting others"];

export const searchArticles = (articles, q) => {
  const words = q.toLowerCase().split(/\s+/).filter(Boolean);
  if (!words.length) return articles;
  return articles.filter((a) => {
    const hay = `${a.title} ${a.description} ${(ARTICLE_TOPICS[a.slug] || []).join(" ")}`.toLowerCase();
    return words.every((w) => hay.includes(w));
  });
};
